import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontColorSelector from '../../helpers/fontColorSelector';
import AlignmentSelector from '../../helpers/textAlignmentSelector';
import './Paragraph.style.scss';

const alignmentSelector = new AlignmentSelector();
const colorPicker = new FontColorSelector();

/**
 * @group Components
 * Paragraph
 */

const Paragraph = (props) => {
  let classString;

  const { opts } = props;
  const { options } = opts;
  if (options) {
    const textAlignment = (options.textAlignment) ? alignmentSelector.get(options) : options.align;
    const colorString = (options.colorPicker) ? colorPicker.get(options) : options.colorclass;
    classString = classNames(
      textAlignment,
      colorString
    );
  }

  let paragraphText = null;
  if (options && options.URL) {
    paragraphText = (
      // eslint-disable-next-line jsx-a11y/control-has-associated-label
      <a
        href={props.opts.options.URL}
        dangerouslySetInnerHTML={{ __html: props.opts.text }}
      />
    );
  } else {
    paragraphText = <span dangerouslySetInnerHTML={{ __html: props.opts.text }} />;
  }
  return (
    <p className={classString}>
      {paragraphText}
    </p>
  );
};

Paragraph.propTypes = {
  opts: PropTypes.shape({
    options: PropTypes.object,
    text: PropTypes.string
  }).isRequired,
  options: PropTypes.shape({
    textAlignment: PropTypes.object,
    align: PropTypes.string,
    URL: PropTypes.string,
  })
};

Paragraph.defaultProps = {
  options: {}
};

export default Paragraph;
